export const ASSOCIATE_CATEGORY_REQUEST = 'portfolio-category/ASSOCIATE_CATEGORY_REQUEST';
export const ASSOCIATE_CATEGORY_SUCCESS = 'portfolio-category/ASSOCIATE_CATEGORY_SUCCESS';
export const ASSOCIATE_CATEGORY_FAILURE = 'portfolio-category/ASSOCIATE_CATEGORY_FAILURE';

export const DEASSOCIATE_CATEGORY_REQUEST = 'portfolio-category/DEASSOCIATE_CATEGORY_REQUEST';
export const DEASSOCIATE_CATEGORY_SUCCESS = 'portfolio-category/DEASSOCIATE_CATEGORY_SUCCESS';
export const DEASSOCIATE_CATEGORY_FAILURE = 'portfolio-category/DEASSOCIATE_CATEGORY_FAILURE';
